import React from 'react';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { PLACEMENT as TOOLTIP_PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { statefulTooltipSidePanelOverrides, TooltipContentLabel } from '../annotation-details/common/tooltip';
import { BUTTON_SIZE } from './constants';
type PropsT = {
  icon: React.ReactNode;
  name: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};
const buttonOverrides = {
  BaseButton: {
    style: {
      height: BUTTON_SIZE,
      width: BUTTON_SIZE
    }
  }
};
export function ActionButton({
  icon,
  name,
  onClick
}: PropsT) {
  return <StatefulTooltip placement={TOOLTIP_PLACEMENT.bottomLeft} overrides={statefulTooltipSidePanelOverrides} content={() => <TooltipContentLabel>{name}</TooltipContentLabel>} showArrow>
      <Button aria-label={name} shape={SHAPE.circle} kind={KIND.tertiary} size={SIZE.compact} overrides={buttonOverrides} onClick={onClick}>
        {icon}
      </Button>
    </StatefulTooltip>;
}